import axios from "axios";

// Backend URL resolution order:
//   1. REACT_APP_BACKEND_URL baked in at build time (used in local/preview dev).
//   2. window.__RUNTIME_CONFIG__.BACKEND_URL from /runtime-config.js (editable on the
//      live server with no rebuild — this is what the production build uses).
const runtimeConfig = (typeof window !== "undefined" && window.__RUNTIME_CONFIG__) || {};
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || runtimeConfig.BACKEND_URL || "";

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const url = cfg?.url || "";
    if (error.response?.status === 401 && !cfg._retry && !url.startsWith("/auth/")) {
      cfg._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(cfg);
      } catch {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export const errorText = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return "Something went wrong. Please try again or contact our office directly.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg || "").replace(/^Value error, /, "")).filter(Boolean).join(" ");
  return String(d.msg || d);
};
